// extracted by mini-css-extract-plugin
module.exports = {"main":"tabs_main__z18Zt","btn":"tabs_btn__F3mr_","atv":"tabs_atv__vIW4u","only":"tabs_only__YVqmw"};